import React from "react";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";

import { useUsers } from "hooks";
import { appRoutes } from "routes";
import Placeholder from "components/Placeholder";
import UserPresenter from "presenters/UserPresenter";

import SectionHeader from "../SectionHeader";

import useStyles from "./useStyles";

const LoginDetails = () => {
  const classes = useStyles();
  const { currentUser } = useUsers();

  return (
    <div className={classes.root}>
      <SectionHeader>Log In Details</SectionHeader>

      <div className={classes.row}>
        <Typography>
          Name:{" "}
          {currentUser ? (
            <b>{UserPresenter.firstName(currentUser)}</b>
          ) : (
            <Placeholder variant="text" className={classes.placeholder} />
          )}
        </Typography>
        <NavLink exact className={classes.link} to={appRoutes.changeNamePath()}>
          Change Name
        </NavLink>
      </div>

      <div className={classes.row}>
        <Typography>
          Email:{" "}
          {currentUser ? (
            <b>{UserPresenter.email(currentUser)}</b>
          ) : (
            <Placeholder variant="text" className={classes.placeholder} />
          )}
        </Typography>
        <NavLink exact className={classes.link} to={appRoutes.changeEmailPath()}>
          Change Email
        </NavLink>
      </div>

      <div className={classes.row}>
        <Typography>
          Password: {currentUser ? <b>**********</b> : <Placeholder variant="text" className={classes.placeholder} />}
        </Typography>
        <NavLink exact className={classes.link} to={appRoutes.changePasswordPath()}>
          Change Password
        </NavLink>
      </div>
    </div>
  );
};

export default LoginDetails;
